import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@material-ui/core";
import {KeyboardDatePicker} from "@material-ui/pickers";
import moment from "moment-timezone";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import { buttonStyle } from "../buttonGroupStyle";
import { compose } from 'recompose';
import withSubordinateUser from './../../../../HOC/withSubordinateUser';
import t from "../../../../../languages/pl";

const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(3)
    },
    row: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(4)
    },
    timePicker: {
        marginLeft: theme.spacing(2)
    }
});

const InspectionSchedule = props => {
    const { classes, title, label, name, onDialogOpen, onSubmit, date: inputDate = 0, nonAdminUser } = props;
    const [open, setOpen] = useState(false);
    const [date, setDate] = useState(inputDate);

    useEffect(() => {
        setDate(inputDate);
    }, [inputDate]);

    const handleStartTimeChange = (e) => {
        setDate(moment(e).unix());
    };

    const handleSubmit = () => {
        if(onSubmit)
            onSubmit(date);
        setOpen(false);
    };

    const handleDialogOpen = () => {
        setOpen(true);
        if(onDialogOpen)
            onDialogOpen();
    };

    return (
        <React.Fragment>
             <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {title}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    {title} {name}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.container}>
                        <div className={classes.row}>
                            <Typography
                                variant="body1"
                            >
                                {label}:
                            </Typography>
                            <KeyboardDatePicker
                                className={classes.timePicker}
                                variant="inline"
                                format="DD-MM-YYYY"
                                invalidDateMessage={t.invalidDateFormat}
                                value={date === 0 ? null : moment.unix(date).format("YYYY-MM-DD")}
                                onChange={handleStartTimeChange}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <CancelAcceptForm onCancel={() => setOpen(false)} onSubmit={handleSubmit} disableSubmit={nonAdminUser} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

InspectionSchedule.propTypes = {
    classes: PropTypes.object,
    name: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    date: PropTypes.number,
    onSubmit: PropTypes.func,
    onDialogOpen: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};

export default compose(
    withStyles(useStyles),
    withSubordinateUser
)(InspectionSchedule);
